var _a;
import { UrlMappingsKeys } from '../url-mappings-keys';
export var groupMapping = (_a = {},
    _a[UrlMappingsKeys.GROUP] = {
        variables: ['groupId', 'tabName'],
        required: ['groupId', 'tabName'],
    },
    _a[UrlMappingsKeys.GROUP_POST] = {
        variables: ['groupId', 'tabName', 'postId'],
        required: ['groupId', 'tabName', 'postId'],
    },
    _a);
//# sourceMappingURL=group.js.map